module.exports = __webpack_public_path__ + "img/pexels-pixabay-220938.50f3d535.jpg";